/** 호스트가 낸 JSON 은 코드 울타리나 앞뒤 설명이 붙을 수 있다. 읽히는 바깥 중괄호 구간만 취한다 */
export function jsonBody(text: string): string {
  const trimmed = text.trim();
  try { JSON.parse(trimmed); return trimmed; } catch { /* 아래에서 구간을 자른다 */ }
  const first = trimmed.indexOf('{');
  const last = trimmed.lastIndexOf('}');
  if (first < 0 || last <= first) return trimmed;
  const slice = trimmed.slice(first, last + 1);
  try { JSON.parse(slice); return slice; } catch { return trimmed; }
}
